"use client";

import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import Link from "next/link";

const features = [
  "Corporate AI Workshops & Seminars",
  "Process Automation Training (n8n, Python)",
  "Data-Driven Culture Building",
  "Custom LLM Integration Training"
];

export function EnablementSection() {
  return (
    <section className="w-full py-24 bg-secondary/30 border-y border-white/5 overflow-hidden">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="space-y-8"
          >
            <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-sm text-primary">
              <span className="mr-2 h-2 w-2 rounded-full bg-primary"></span>
              BornAI Academy
            </div>
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl text-white">
              Empowering Your Teams to <br />
              <span className="text-primary">Speak the Language of AI</span>
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed">
              We don't just deliver software; we transfer knowledge. Our enablement programs ensure your workforce is ready to embrace automation, manage AI tools, and optimize workflows independently.
            </p>
            <ul className="space-y-4">
              {features.map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-white/80">
                  <CheckCircle2 className="h-5 w-5 text-accent" />
                  {item}
                </li>
              ))}
            </ul>
            <Button size="lg" asChild className="bg-white text-secondary hover:bg-white/90 font-semibold mt-4">
              <Link href="/academy">
                Explore Training Programs
              </Link>
            </Button>
          </motion.div>
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-primary/20 blur-[80px] rounded-full"></div>
            <div className="relative rounded-xl border border-white/10 bg-[#020617] shadow-2xl overflow-hidden">
              <div className="flex items-center gap-2 border-b border-white/10 bg-white/5 px-4 py-3">
                <div className="h-3 w-3 rounded-full bg-red-500/50"></div>
                <div className="h-3 w-3 rounded-full bg-yellow-500/50"></div>
                <div className="h-3 w-3 rounded-full bg-green-500/50"></div>
                <div className="ml-2 text-xs text-muted-foreground font-mono">born-ai-training — -zsh</div>
              </div>
              <div className="p-6 font-mono text-sm space-y-4">
                <div className="flex gap-2">
                  <span className="text-accent">➜</span>
                  <span className="text-blue-400">~</span>
                  <span className="text-white">initiate_workshop.sh</span>
                </div>
                <div className="text-muted-foreground">
                  Loading modules...<br/>
                  [OK] Introduction to Generative AI<br/>
                  [OK] Workflow Automation with n8n<br/>
                  [OK] Data Security Protocols<br/>
                  <br/>
                  <span className="text-primary">Ready to transform your workforce.</span>
                </div>
                <div className="mt-4 rounded bg-white/5 p-3 border border-white/5">
                  <span className="text-purple-400">def</span> <span className="text-yellow-300">optimize_process</span>(data):<br/>
                  &nbsp;&nbsp;<span className="text-purple-400">return</span> data * <span className="text-orange-400">AI_EFFICIENCY</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}